// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1EHeP","cell":"ColumnAccessor_cell__3LNDX","firstCellAccent":"ColumnAccessor_firstCellAccent__3wgOi"};